import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './orders.import.actions';

const initialState = {
  storeGuid: null,
  mappings: [],
  mappingName: null,
  mappingGuid: null,
  error: null,
  batchNumber: null,
  importedCols: [],
  shipStationCols: [],
  mappingModalId: null,
  importLogModalId: null,
  importProgressNotificationId: null,
  isLoading: false,
  importLog: null,
};

const setIsLoadingTrue = (state) => {
  return {
    ...state,
    isLoading: true,
  };
};

const setError = (state, { error }) => {
  return {
    ...state,
    error,
  };
};

const storeResponse =
  (responseKey) =>
  (state, { response }) => {
    return {
      ...state,
      [responseKey]: response,
    };
  };

const actionHandlerMap = {
  [Actions.INITIATE_START_IMPORT_ORDERS]: setIsLoadingTrue,
  [Actions.INITIATE_GET_IMPORT_MAPPINGS]: setIsLoadingTrue,
  [Actions.UPLOAD_ORDERS_CSV_FAILURE]: setError,
  [Actions.GET_IMPORT_MAPPINGS_FAILURE]: setError,
  [Actions.START_IMPORT_ORDERS_FAILURE]: setError,
  [Actions.GET_ORDER_IMPORT_STATUS_LOG_FAILURE]: setError,
  [Actions.RENAME_SAVED_IMPORT_MAPPING_FAILURE]: setError,
  [Actions.START_IMPORT_ORDERS_SUCCESS]: storeResponse('stores'),
  [Actions.SET_SELECTED_IMPORT_STORE_GUID]: (state, { storeGuid }) => {
    return {
      ...state,
      storeGuid,
    };
  },
  [Actions.SET_ORDER_IMPORT_MAPPING_NAME]: (state, { mappingName }) => {
    return {
      ...state,
      mappingName,
    };
  },
  [Actions.ORDER_IMPORT_MAPPING_MODAL_OPENED]: (state, { modalId }) => {
    return {
      ...state,
      mappingModalId: modalId,
    };
  },

  [Actions.ORDER_IMPORT_PROGRESS_NOTIFICATION_OPENED]: (state, { notificationId }) => {
    return {
      ...state,
      importProgressNotificationId: notificationId,
    };
  },

  [Actions.INITIATE_ORDERS_CSV_UPLOAD]: (state, { mappingName }) => {
    return {
      ...state,
      isLoading: true,
      mappingName,
    };
  },
  [Actions.UPLOAD_ORDERS_CSV_SUCCESS]: (state, { response }) => {
    const { csvColumns, orderFields, importGuid } = response;
    return {
      ...state,
      importedCols: csvColumns,
      shipStationCols: orderFields,
      batchNumber: importGuid,
      isLoading: false,
    };
  },

  [Actions.GET_IMPORT_MAPPINGS_SUCCESS]: (state, { response: { data } }) => {
    return {
      ...state,
      mappings: data,
      mappingName: data.length > 0 ? data[0].name : null,
      isLoading: false,
    };
  },

  [Actions.GET_ORDER_IMPORT_STATUS_LOG_SUCCESS]: (state, { response }) => {
    return {
      ...state,
      importLog: response,
      isLoading: false,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './orders.import.reducer.metadata';
